
import { presentationCredentialConstants } from '../constants/PresentationCredentialConstants'
import { presentationRequests } from '../../services/PresentationRequest'
import { handleErrorMessage } from '../../utils'

export const presentationCredentialActions = {}


presentationCredentialActions.GetPresentation = (data, isReset = false) => {
  console.log('dataToken', data, isReset)

  return dispatch => {
    if (isReset) {
      dispatch(reset())
    } else {
      dispatch(request())
      presentationRequests.GetPresentation(data)
        .then(
          data => dispatch(success(data)),
          error => dispatch(failure(handleErrorMessage(error)))
        )
    }
  }

  function reset() {
    return { type: presentationCredentialConstants.VERIFY_CREDENTIAL_RESET }
  }

  function request() {
    return { type: presentationCredentialConstants.VERIFY_CREDENTIAL_REQUEST }
  }

  function success(object) {
    return { type: presentationCredentialConstants.VERIFY_CREDENTIAL_SUCCESS, object }
  }

  function failure(error) {
    return { type: presentationCredentialConstants.VERIFY_CREDENTIAL_FAILURE, error }
  }

}





